import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'SHUTDOWN_REASON_QUERY_MAIN',
    method: 'GET',
  });

  useEffect(() => {
    if (params && params['mach_oids'].length !== 0) {
      let url = `/api/shutdown/reason/search/main`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  //console.error('GETmain==>', JSON.stringify(data));
  return [isRequestSuccessed, data || [], exec];
  // }
});
